import React from 'react'
import Block from './Block'
import P from './P'
import { Code } from 'rebass'

const Lost = ({ tag }) => (
  <Block tint={120} icon={['fab', 'github']} header="Got lost?">
    <P>
      The code up to this point is in the tag <Code>{tag}</Code> of the
      repository{' '}
      <Code>https://github.com/Limenius/workshop-symfony-react.git</Code>
    </P>
    <P>This means:</P>
    <P>
      <Code>git reset HEAD --hard</Code>
    </P>
    <P>(To discard your changes)</P>
    <P>And then:</P>
    <P>
      <Code>git checkout {tag}</Code>
    </P>
  </Block>
)

export default Lost



// WEBPACK FOOTER //
// ./src/components/Lost.js